<template>
  <span>
    <span v-if="documentType == 'BankOrder'">Banka Talimatı</span>
    <span v-else-if="documentType == 'Contract'">Sözleşme</span>
    <span v-else-if="documentType == 'General'">Genel</span>
    <i v-else class="text-muted">Bilinmiyor</i>
  </span>
</template>
<script>
export default {
  props: {
    documentType: String
  }
};
</script>
